import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect () {
    console.log("SharedUI Demo ViewComponent Connected");
    this.element.addEventListener("click", () => { alert("SharedUI Component was clicked!"); });
  }
}
